import { render } from "./popup.vue?vue&type=template&id=384cb3c0&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=384cb3c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384cb3c0"]])

export default __exports__